<template>
    <div>
        <label for="cicloEscolar" class="labelInput">
            Ciclo Escolar
        </label>
        <vs-select filter :loading="loadingCicloEscolar" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" @change="$emit('filtroPadre', cicloEscolar, 'cicloEscolar')">
            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                Requerido
            </template>
            <vs-option v-for="(option, index) in ciclosEscolares" :key="index"  :label="option.text" :value="option.id">
                {{option.text}}
            </vs-option>
        </vs-select>
    </div>
</template>

<script>
import filtros from '../../../api/requests/filtros'
export default {
    props: [
        'institucion',
        'errorFields'
    ],
    data(){
        return{
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCicloEscolar: false
        }
    },
    methods: {
        async getCicloEscolar() {
            this.cicloEscolar = ''
            try {
                this.loadingCicloEscolar = true
                const { data: response } = await filtros.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCicloEscolar = false
            }catch(error){
                this.loadingCicloEscolar = false
                console.log(error)
            }
        },
    },
    watch:{
        institucion(){
            this.getCicloEscolar()
        }
    }
}
</script>